import { MapKeyCiudad } from 'src/app/pago/enums/MapKeyCiudad.enum';

export const MAPS_KEY_NORMALIZE_CIUDAD = {
  codigo: MapKeyCiudad.CODIGO,
  nombre: MapKeyCiudad.NOMBRE,
  departamento_codigo: MapKeyCiudad.DEPARTAMENTO_CODIGO,
  permitida: MapKeyCiudad.PERMITIDA,
};
